// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/number';
import 'core-js/shim';

import Vue from 'vue';
import App from './App';
import router from './router';
import VueRouter from 'vue-router'
import { store } from './store/store';
import VueGtag from "vue-gtag";

/*Bootstrap Vue start */
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
/*Bootstrap Vue End */

import linkify from 'vue-linkify';
Vue.directive('linkified', linkify);

import VeeValidate from 'vee-validate';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import datePicker from 'vue-bootstrap-datetimepicker';
Vue.component('datePicker', datePicker);

Vue.use(VueAxios, axios);
Vue.use(VeeValidate);
Vue.use(VueRouter);

Vue.config.productionTip = false;

// Configuration Gtag-Analytics
if (process.env.PRODUCTION_COUNTRY == "AU" && process.env.APP_ENV == "production") {
    Vue.use(VueGtag, {
      config: { 
        id: process.env.ANALYTICS_ID,
      },
    }, router);

}

/* eslint-disable no-new */
var vm = new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js